import { NumberUtils } from '@ca/common'

/** Parse a raw vbox string to millimeters. Returns undefined unless finite > 0. */
export const parseVbox = (raw?: string): number | undefined => {
  const value = NumberUtils.parse.toFloatOrNull(raw ?? '')
  if (value == null || value <= 0) return undefined
  return value
}

/** Vbox as shown on the chip and prefilled into the input ("42", "42.5"). */
export const formatVbox = (vboxMm?: number): string => {
  if (!vboxMm || vboxMm <= 0) return ''
  return String(Number(vboxMm.toFixed(1)))
}
